<template>
  <div>
    <f7-list accordion-list class="itemList" style="font-size:16px">
      <f7-accordion-item class="accordionForm" :expanded="false" v-for="(project, index) in projectsInformation" :key="project.IdGroup"
        @accordion:open="getInvoices(index)">
        <f7-accordion-toggle class="accordionToggle">
          <ul>
            <li class="swipeout">
              <div class="swipeout-content">
                <div class="item-content boxRequest">
                  <div class="item-media">
                  </div>
                  <div class="item-inner">
                    <table width="100%">
                      <tr>
                        <td style="width: 45%;min-width: 45%;max-width: 45%;">
                          {{ project.Name }}
                          <div>
                            <span class="statusLabel showLargeScreenOnly">
                              {{ $t('common.status.status_label') + ': ' + getStatusLabel(project.Status) }}
                            </span>
                          </div>
                          <div class="showSmallScreenOnly">
                            <div class="item-subtitle showSmallScreenOnly"
                              style="white-space:normal">
                              {{ $t('common.amnt') + ': ' + project.Amount + ' €'}}
                            </div>
                          </div>
                          <div class="showSmallScreenOnly">
                            <div class="statusLabel">
                              {{ $t('common.status.status_label') + ': ' + project.Status }}
                            </div>
                          </div>
                        </td>
                        <td style="width: 45%;min-width: 45%;max-width: 45%;" class="showLargeScreenOnly">
                          {{ $t('common.amnt') + ': ' + project.Amount + ' €'}}
                        </td>
                        <td class="showLargeScreenOnly" style="width: 25%;min-width: 25%;max-width: 25%;">
                          <!-- Eventually a customer name here -->
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </f7-accordion-toggle>
        <f7-accordion-content>
          <spinner v-if="projects[index] === undefined || projects[index].Invoices === undefined"></spinner>
          <invoices-list
            v-else-if="projects[index].Invoices.length > 0"
            :filterBy="false"
            :invoices="projects[index].Invoices"
            :showInvoiceMainDetails="false">
          </invoices-list>
          <div v-else style="text-align: center;background: #dcdcdc;">
            {{ $t('common.no_invoice_yet') }}
          </div>
        </f7-accordion-content>
      </f7-accordion-item>
    </f7-list>
  </div>
</template>
<script>
import _ from 'lodash'
import Spinner from '@/components/common/spinner.vue'
import InvoicesList from '@/pages/requests/detailPages/invoiceDetailPages/InvoicesList.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {statusLabel, statusIcon} from '@/helpers/labels'

export default {
  name: 'ProjectDetails',
  props: ['projectsInformation'],
  components: {
    'invoices-list': InvoicesList,
    'spinner': Spinner
  },
  data () {
    return {
      projects: []
    }
  },
  methods: {
    getIcon (status) {
      return statusIcon('Seller_' + status)
    },
    getInvoices (index) {
      if (!this.projects[index]) {
        this.projects[index] = _.cloneDeep(this.projectsInformation[index])
        let that = this
        this.$engine.services.payments.getInvoices({
          IdGroupPayment: this.projects[index].IdGroup
        }).then(resp => {
          console.log(resp.data)
          that.projects[index].Invoices = resp.data.Invoices
          that.projects = _.cloneDeep(that.projects)
          // this.projects[index].Payments = resp.data.groups
        }).catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
        // this.projects[index].Payments = []
      }
    },
    getStatusLabel (status) {
      return statusLabel(this.$i18n, 'Seller_' + status)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectDetails.vue?13954467